// temp data
const subject = [
  {
    userName: '每日分享',
    avatar: './static/av1.jpg',
    msg: [
      {
        time: '11:40',
        content: '今天也要保持好心情。'
      },
      {
        time: '11:40',
        content: '分享一张今天拍的照片。'
      }
    ]
  },
  {
    userName: '前端交流',
    avatar: './static/av2.jpg',
    msg: [
      {
        time: '11:40',
        content: '有空一起交流一下最近的项目吧。'
      },
      {
        time: '11:40',
        content: '好的，晚点把资料发给你。'
      }
    ]
  }
]

export default subject



// WEBPACK FOOTER //
// ./src/store/subject.js